export const isDevelopment = () => {
    if (process.env.NODE_ENV === "development") {
        return true;
    }
    else if (window.location.host.indexOf("localhost") > 0) {
        return true;
    }

    return false;
};